import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../../Assets/images/Airswift Primary Logo (Black Text).png';
import styles from './RightToBeForgotten.module.scss';
import ThankYou from './ThankYou';

function RightToBeForgotten() {
  const [formFilled, setFormFilled] = useState(false);
  const [username, setUsername] = useState('');
  const { t } = useTranslation();
  return formFilled ? (
    <ThankYou />
  ) : (
    <form
      onSubmit={() => {
        setFormFilled(true);
      }}
      className={`col px-1 px-sm-5 mb-3 ${styles.rtfb}`}
    >
      <img className={`mb-3 ${styles.rtfb__image}`} src={logo} alt="" />
      <div className={`py-5 ${styles.rtfb__content}`}>
        <p className={styles.title}>{t('profile.rtbf.title')}</p>
        <p className={styles.subtitle}>{t('profile.rtbf.description')}</p>
        <div className={`mb-3 ${styles.form}`}>
          <div className={styles.form__inputField}>
            <label className={styles.label} htmlFor="name">
              {t('profile.rtbf.name')}*
            </label>
            <input
              onChange={(e) => setUsername(e.target.value)}
              required
              className={styles.input}
              type="text"
              id="name"
            />
          </div>
          <div className={styles.form__inputField}>
            <label className={styles.label} htmlFor="email">
              {t('profile.rtbf.email')}*
            </label>
            <input required className={styles.input} type="email" id="email" />
          </div>
        </div>

        <p className={styles.policy}>{t('profile.rtbf.footertext')}</p>
        <button className={` mt-4 ${styles.btn}`} type="submit">
          <a
            className={styles.mailLink}
            href={`mailto:dpo@airswift.com?subject=right to be forgotten
            &body=
            Dear DPO,

            The user ${username} has requested the Right to Be Forgotten. 
            Please review this request and advise accordingly within 1 calendar month.
            
            Thank you.`}
          >
            {t('common.general.submit')}
          </a>
        </button>
      </div>
    </form>
  );
}

export default RightToBeForgotten;
